import { HTTP } from '@/services/axios';

export async function getContacts({filterText,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/customMailing/MailingContacts/getContacts.php',{
        params:{
            filterText,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getContact({contactId}){
    let result = {};
    
    await HTTP({
        method: 'get',
        url: `/app/customMailing/MailingContacts/getContactData.php?contactId=${contactId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });
    return result;
}

export async function unlockContact(contactId){
    let result = {};

    var data = {'contactId':contactId}
    
    await HTTP({
        method: 'patch',
        url: '/app/customMailing/MailingContacts/controlContactUnlock.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function changeStateContact({recordId,state}){
    let result = {};

    var data = {'recordId':recordId,'state':state}
    
    await HTTP({
        method: 'patch',
        url: '/app/customMailing/MailingContacts/controlContactChangeState.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function createContact({data,optionsCategories}){
    let result = {};
    console.log(data);
    var bodyFormData = new FormData();
	bodyFormData.set('myData',JSON.stringify(data));
	bodyFormData.set('myOptionsCategories',JSON.stringify(optionsCategories));
    
    var datas = {'data':data,'myOptionsCategories':optionsCategories}

    await HTTP({
        method: 'post',
        url: '/app/customMailing/MailingContacts/controlContactSave.php',
        data: datas
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveContact({data,optionsCategories}){
    let result = {};
    
    var bodyFormData = new FormData();
	bodyFormData.set('myData',JSON.stringify(data));
	bodyFormData.set('myOptionsCategories',JSON.stringify(optionsCategories));
    
    var datas = {'data':data,'myOptionsCategories':optionsCategories}

    await HTTP({
        method: 'put',
        url: '/app/customMailing/MailingContacts/controlContactSave.php',
        data: datas
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}


export async function deleteContact({data}){
    let result = {};

    await HTTP({
        method: 'delete',
        url: '/app/customMailing/MailingContacts/controlContactDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

// import contacts
export async function getDataToUpload(file){
    let result = {};

    await HTTP({
        method: 'post',
        url: '/app/customMailing/MailingContacts/controlContactsLoadUploadFiles.php',
        data: file
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function uploadFile(){
    return "/app/customMailing/MailingContacts/controlContactsUpload.php";
}

export async function importContact({importedData,categoryId}){
    let result = {};

    var datas = {importedData,categoryId}

    await HTTP({
        method: 'post',
        url: '/app/customMailing/MailingContacts/controlContactsImport.php',
        data: datas
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}